import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {useAuth} from "../../../context/authContext";
import {authorizedGetMessage, closeMessage, getMessage, setMessage} from '../../../actions/broadcastMessengerActions';

import {
    BroadcastMessage,
    ExitBtn,
    ExitBtnWrap,
    ExitIcon,
    ExitSpace,
    ExitWrapper,
    Label,
    LabelContainer,
    MessageInnerContainer,
    MessageInnerWrapper,
    MessageOuterContainer,
    MessageOuterWrapper,
    MessageOutline,
    Spacing
} from '../../../components/messageStyles';

const Message = () => {
    const auth = useAuth();
    const token = auth.getAuthToken();
    const dispatch = useDispatch();
    const { message } = useSelector((state) => state.broadcastMessenger);

    const [hidden, setHidden] = useState(true);
    const [msg, setMsg] = useState(null);
    const [count, setCount] = useState(0);
    const [difference, setDifference] = useState(0);
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const checkForMessage = useCallback(async () => {
        if (auth.isAuthenticated()) {
            return await authorizedGetMessage(token);
        } else {
            return await getMessage();
        }
    }, [auth, token]);

    useEffect(() => {
        let isMounted = true;
        const loadMessage = async () => {
            const result = await checkForMessage();
            if (!isMounted || !result) {
                return;
            }
            if (message && result.expires !== message.expires) {
                dispatch(setMessage(result));
            }
            if ((msg === null && result) || (msg !== null && result.expires !== msg.expires)) {
                setMsg(result);
                setHidden(false);
                const current = new Date();
                const exp = new Date(result.expires);
                const diff = (current - exp);
                setDifference(diff);
            }
        };

        loadMessage();
        const pollTimer = setTimeout(() => {
            if (isMounted) {
                setCount((prev) => prev + 1);
            }
        }, 60000);

        return () => {
            isMounted = false;
            clearTimeout(pollTimer);
        };
    }, [message, count, msg, dispatch, checkForMessage]);

    useEffect(() => {
        if (hidden) {
            return undefined;
        }
        if (difference > 0) {
            setHidden(true);
            return undefined;
        }

        const hideTimer = setTimeout(() => {
            setHidden(true);
        }, Math.abs(difference));

        return () => clearTimeout(hideTimer);
    }, [difference, hidden]);

    const hideMessage = async () => {
        if (auth.isAuthenticated()) {
            await closeMessage();
            if (isMountedRef.current) {
                setHidden(true);
            }
        } else if (isMountedRef.current) {
            setHidden(true);
        }
    }

    return (
        <>
            {difference <= 0 && !hidden ? (
                <MessageOutline className="mb-3">
                    <MessageOuterWrapper>
                        <MessageInnerWrapper>
                            <MessageOuterContainer>
                                <BroadcastMessage broadcast={msg}>
                                    <MessageInnerContainer>
                                        <LabelContainer>
                                            <Label>{msg.message}</Label>
                                        </LabelContainer>
                                        <Spacing></Spacing>
                                        <ExitWrapper>
                                            <ExitBtn>
                                                <ExitBtnWrap onClick={hideMessage}>
                                                    <ExitIcon><i className="fa-solid fa-xmark"></i></ExitIcon>
                                                    <ExitSpace></ExitSpace>
                                                </ExitBtnWrap>
                                            </ExitBtn>
                                        </ExitWrapper>
                                    </MessageInnerContainer>
                                </BroadcastMessage>
                            </MessageOuterContainer>
                        </MessageInnerWrapper>
                    </MessageOuterWrapper>
                </MessageOutline>
            ) : null}
        </>
    );
}

export default Message;
